import { AxiosInstance } from 'axios';
import { atom } from 'jotai';
import { ResourceHeadersWithToken } from '../../services/useResource';
import { ConnectionState } from '../../types/sse/connectionState';

export type FunctionAtom<T> = {
  fn: () => T;
};

export const eStreamConnectionStateAtom = atom<ConnectionState | undefined>(undefined);

export const realtimeMarketsAtom = atom<Array<string>>([]);

export const axiosInstanceAtom = atom<FunctionAtom<AxiosInstance> | undefined>(undefined);

export const getResourceHeadersWithTokenAtom = atom<undefined | FunctionAtom<() => ResourceHeadersWithToken>>(
  undefined,
);

export const eStreamSessionIdAtom = atom<string | undefined>(undefined);
